"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var DynamicThemeComponent_1 = require("../DynamicThemeComponent");
var TextInputType;
(function (TextInputType) {
    TextInputType["Text"] = "text";
    TextInputType["Password"] = "password";
})(TextInputType || (TextInputType = {}));
exports.TextInputType = TextInputType;
var TextFieldBase = /** @class */ (function (_super) {
    tslib_1.__extends(TextFieldBase, _super);
    function TextFieldBase(props) {
        var _this = _super.call(this, props) || this;
        _this.handleInputActive = function (active) {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ inputActive: active });
        };
        _this.handleInputFocus = function (focus) {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ inputFocus: focus });
        };
        _this.handleBlur = function () {
            if (_this.props.disabled) {
                return;
            }
            if (_this.props.handleBlur) {
                _this.props.handleBlur();
            }
        };
        _this.handleInputHover = function (hover) {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ inputHover: hover });
        };
        _this.state = tslib_1.__assign(tslib_1.__assign({}, _this.state), { inputFocus: false, inputActive: false, inputHover: false });
        return _this;
    }
    TextFieldBase.prototype.isInputActiveOrHasFocus = function () {
        return this.state.inputActive || this.state.inputFocus;
    };
    /**
     * Show placeholder if there is no text
     */
    TextFieldBase.prototype.isPlaceholderShowing = function () {
        return !this.props.text;
    };
    TextFieldBase.defaultProps = {
        shouldSelectTextOnFocus: true
    };
    return TextFieldBase;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.TextFieldBase = TextFieldBase;
//# sourceMappingURL=TextFieldBase.js.map